import { selectReportDownloadViewModel } from "@/features/reports/view-models/select-report-download.view-model";
import { Button } from "@spz/ui/components/button";
import { Icon } from "@spz/ui/components/icon";
import { Typography } from "@spz/ui/components/typography";
import { useTranslation } from "react-i18next";
import SpzLogo from "../assets/logo-spz.svg";

const ReportDownloadPage = () => {
  const { t } = useTranslation();
  const { onNavigateToSupervizor, triggerDownload } =
    selectReportDownloadViewModel();

  return (
    <div className="h-screen">
      <div className="flex items-center justify-center h-full bg-gray-50 rounded-md overflow-auto">
        <div className="flex flex-col w-full max-w-[534px] gap-[64px]">
          <div>
            <img src={SpzLogo} alt="SpzLogo" className="w-[172px]" />
          </div>
          <div>
            <div className="text-gray-900 mb-2 flex">
              <Icon icon="download" size={48} />
              <Typography trans="your_file_is_ready" variant="h3" />
            </div>

            <Typography
              trans="download_will_begin_automatically"
              className="text-gray-700"
            />
            <div className="text-gray-700">
              <Typography>
                {t("not_working")}
                <Button
                  variant={"link"}
                  onClick={triggerDownload}
                  className="py-0 h-min text-gray-700 underline" // to erase buttons classes
                >
                  {t("click_here_to_download")}
                </Button>
              </Typography>
            </div>
          </div>
          <Button
            className="max-w-fit font-semibold"
            rightIcon="chevron-right"
            onClick={onNavigateToSupervizor}
          >
            {t("go_to_supervizor")}
          </Button>
        </div>
      </div>
    </div>
  );
};
export default ReportDownloadPage;
